import { render, staticRenderFns } from "./IU.vue?vue&type=template&id=0a6b91db&scoped=true&"
import script from "./IU.vue?vue&type=script&lang=js&"
export * from "./IU.vue?vue&type=script&lang=js&"
import style0 from "./IU.vue?vue&type=style&index=0&id=0a6b91db&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b91db",
  null
  
)

export default component.exports